import Vue from 'vue'
import Router from 'vue-router'
import AppSideBar from './components/AppSidebar.vue'


Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      components: {
        landing: () => import('./views/Home.vue')
      }
    },
    {
      path: '/login',
      name: 'login',
      components: {
        login: () => import('./views/Login.vue')
      } 
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/Dashboard.vue')
      } 
    },
    {
      path: '/signup',
      name: 'signUp',
      components: {
        content: () => import('./views/SignUp.vue')
      } 
    },
    {
      path: '/request-reset-password',
      name: 'requestResetPassword',
      components: {
        content: () => import('./views/RequestResetPassword.vue')
      } 
    },
    {
      path: '/reset-password',
      name: 'ResetPassword',
      components: {
        content: () => import('./views/ResetPassword.vue')
      } 
    },
    {
      path: '/member-management',
      name: 'memberManagement',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/transaction/MemberManagement.vue')
      } 
    },
    {
      path: '/member-management/detail',
      name: 'memberManagementDetail',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/transaction/MemberManagementDetail.vue')
      } 
    },
    {
      path: '/member-management/approvalbymember',
      name: 'memberApproval',
      components: {
        content: () => import('./views/MemberApproval.vue')
      } 
    },
    {
      path: '/user-profile',
      name: 'userProfile',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/UserProfile.vue')
      } 
    },
    //master-data
    {
      path: '/customer',
      name: 'customer',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/transaction/Customer.vue')
      } 
    },
    {
      path: '/customer/detail',
      name: 'customerDetail',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/transaction/CustomerDetail.vue')
      } 
    },
    {
      path: '/supplier',
      name: 'supplier',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/transaction/Supplier.vue')
      } 
    },
    {
      path: '/supplier/detail',
      name: 'supplierDetail',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/transaction/SupplierDetail.vue')
      } 
    },
    {
      path: '/uom',
      name: 'uom',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/transaction/UOM.vue')
      } 
    },
    {
      path: '/uom/detail',
      name: 'uomDetail',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/transaction/UOMDetail.vue')
      },
    },
    {
      path: '/warehouse',
      name: 'warehouse',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/master/Warehouse.vue')
      } 
    },
    {
      path: '/warehouse/detail',
      name: 'warehouseDetail',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/master/WarehouseDetail.vue')
      } 
    },
    {
      path: '/product',
      name: 'product',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/master/Product.vue')
      } 
    },
    {
      path: '/product/detail',
      name: 'productDetail',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/master/ProductDetail.vue')
      } 
    },
    //transaction
    {
      path: '/sales',
      name: 'sales',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/transaction/Sales.vue')
      } 
    },
    {
      path: '/sales/detail',
      name: 'salesDetail',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/transaction/SalesDetail.vue')
      } 
    },
    {
      path: '/purchase',
      name: 'purchase',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/transaction/Purchase.vue')
      } 
    },
    {
      path: '/purchase/detail',
      name: 'purchaseDetail',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/transaction/PurchaseDetail.vue')
      } 
    },
    // Utility
    {
      path: '/stock-on-hand',
      name: 'stockOnHand',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/transaction/StockOnHand.vue')
      } 
    },
    //report
    {
      path: '/print/purchase-detail',
      name: 'purchaseDetailReport',
      components: {
        content: () => import('./views/reports/ReportPurchase.vue')
      } 
    },
    {
      path: '/print/sales-detail',
      name: 'salesDetailReport',
      components: {
        content: () => import('./views/reports/ReportSales.vue')
      } 
    },
    {
      path: '/report/sales-period',
      name: 'reportSales',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/reports/ReportSalesPeriod.vue')
      } 
    },
    {
      path: '/report/purchase-period',
      name: 'reportPurchase',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/reports/ReportPurchasePeriod.vue')
      } 
    },
    {
      path: '/report/daily-mutation',
      name: 'reportDailyMutation',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/reports/ReportDailyMutation.vue')
      } 
    }
  ]
})
